import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22fmxh06uic3p">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="22divinsibn62">
        <div className="text-center" data-id="element-22" data-mp="1ydrxq04kc6s1">
          <GiftIcon className="mx-auto h-10 w-10 text-teal" data-id="element-23" data-mp="1yet9k6tekxat" />
          <p className="mt-4 text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-24" data-mp="1annvnx70wf35">Siempre incluidos · siempre gratis</p>
          <h2 id="bonus-title" className="mt-3 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-25" data-mp="15qxet7ne9fgo">Los 4 bonos estratégicos</h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="1jilnt22cjntf">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-line bg-white p-6 shadow-card" data-id="element-27" data-mp="qywzu5ghmslp" data-mpi={index}>
                <span className="mb-5 flex h-10 w-10 items-center justify-center rounded-lg bg-aquaSoft text-teal" data-id="element-28" data-mp="2jio65gezxk0y">
                  <Icon className="h-5 w-5" data-id="element-29" data-mp="2oitt4jabmicp" />
                </span>
                <p className="text-[10px] font-extrabold uppercase tracking-wider text-teal" data-id="element-30" data-mp="1qus3zw6nqzws">Bono {bonus.number}</p>
                <h3 className="mt-2 text-xl font-bold text-ink" data-id="element-31" data-mp="1vuegu4ikqe52">{bonus.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted" data-id="element-32" data-mp="20ptuavco680y">{bonus.description}</p>
                <p className="mt-5 flex items-center justify-between border-t border-line pt-4 text-sm" data-id="element-33" data-mp="25s2lbm5zf00f">
                  <span className="text-muted line-through" data-id="element-34" data-mp="3c6ad8ynfn6sk">Valor {bonus.value}</span>
                  <span className="font-extrabold text-teal" data-id="element-35" data-mp="3h43fxhpj1io3">GRATIS</span>
                </p>
              </motion.article>;
        })}
        </div>

        <p className="mx-auto mt-8 max-w-xl rounded-xl border border-teal/20 bg-aquaSoft px-5 py-4 text-center text-sm text-teal" data-id="element-36" data-mp="1c4u1fnle4lg5">
          Valor total de los 4 bonos <span className="mx-1 text-muted line-through" data-id="element-37" data-mp="1q1zc60w1u8hq">$68.000 ARS</span>
          <b className="font-extrabold" data-id="element-38" data-mp="1m300lxftbdhb">→ GRATIS con tu Megapack</b>
        </p>
      </div>
    </section>;
}